export interface IAction {
    Type: Actions;
    Payload: [string, any];
}

export enum Actions {
    SHOW_OVERLAY,
    HIDE_OVERLAY,
}

export enum Boolean {
    TRUE,
    FALSE,
}

export enum CallbackRequestStatus {
    SUCCESS,
    FAIL,
}

export enum TourType {
    NONE,
    ESCORTED_TOURS,
    CRUISE_HOLIDAYS,
    SELFDRIVE_TOURS,
    PRIVATE_TOURS,
}

export enum TourTypeCode {
    NONE,
    E,
    C,
    D,
    O,
}

export enum pageIdentity {
    "homepage",
    "flights",
    "flightspromotion",
    "flightspromotionnovideo",
    "flightsmain",
    "magazine",
    "lounges",
    "hoteldescription",
    "hotelsearch",
    "hotelstoplevel",
    "toursmain",
    "toursearchresults",
    "tourdescription",
    "legal",
}

export interface IToursJSON {
    TourChips?: ITourChip[];
    TourDetails?: ITourDetails[];
    ToursMissing?: IToursMissing;
    IsTheLastOf?: any;
}

export interface ITourChip {
    Count: number;
    Title: string;
}

export interface ITourDetails {
    Days: number;
    Description: string;
    DescriptionHeader: string;
    LocationId: number;
    Price: number;
    TourId: number;
    TourImageURL: string;
    TourName: string;
    TourURL: string;
    MainLocation: string;
    Type?: string;
}

export interface IToursMissing {
    NewLocation: string;
    OriginalLocation: string;
}

export interface ISliderOptions {
    nameForGoogleAnalytics: string;
    stageSelector: string;
    outerStageSelector: string;
    cardSelector: string;
    paginationSelector: string;
    dotSelector: string;
    prevSelector: string;
    nextSelector: string;
    sliderId: number;
    visibleCards: number;
    popups: boolean;
    wistia: boolean;
}

export interface IPopupSettings {
    offerStageSelector: string;
    offerUniqueSelector: string;
    sliderId: number;
}

export interface IStarRatingInfo {
    starRating: number;
    hotelCount: number;
    hotelsShowing: number;
}

export interface IHotelSearchResult {
    Id: number;
    Name: string;
    StarRating: string;
    ChoppedDescription: string;
    Price: number;
    ImageURL: string;
    HotelURL: string;
    OfferText: string;
    HasSpecialOffer: boolean;
    OfferDetails?: IHotelSearchResultJSONOfferDetails;
}

export interface IHotelSearchResultJSONOfferDetails {
    URL: string;
    Headline: string;
    ImageURL: string;
    Saving: string;
    NoOfNights: number;
    NoOfDays: number;
    Price: number;
    LongDescription: string;
    ValidFrom: string;
    ValidTo: string;
}

export interface IStayedHereInfo {
    VisitedName: string;
    VisitedPhone: string;
}

export interface IHotelNameSearchItem {
    GlobalPropertyNodeId: number;
    Name: string;
    HotelURL: string;
}

export interface IXMLHttpConfig {
    Url: string;
    Params: string | any;
    Headers: string | any;
}

export interface IFeedback {
    ClientName: string;
    Comments: string;
    DateTimeApproved: string;
    Destination: string;
    Rating: number;
    ReturnDate: string;
    ReturnDateFormatted: string;
}

export interface ICallbackResponse {
    Message: string;
    Status: number;
}

export interface IGeocoderSettings {
    address: string;
    region?: string;
}



// WEBPACK FOOTER //
// ./src/global/types.ts